import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ReactiveFormsModule } from '@angular/forms';
import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import {
  MomentsInitModel,
  MomentsInitVariables,
  MomentsModel,
  MomentsVariables,
} from '../../../../../models/email-template/moments.interface';
import { BaseComponent } from '../../../common/BaseComponent';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-moments',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './moments.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './moments.component.scss'
})
export class MomentsComponent extends BaseComponent implements OnInit {
  @Input() block: MomentsModel = new MomentsInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>(); // Event emitter to send data to the parent
  @Output() removeBlockEvent = new EventEmitter<string | null>(); // New EventEmitter for remove

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new MomentsInitVariables()
    }
  }

  //placeholders:
  imageDesktopPlaceholder: string = 'Desktop Image';
  imageMobilePlaceholder: string = 'Mobile Image';
  hrefPlaceholder: string = 'Enter Image Redirect link';
  altPlaceholder: string = 'Enter Image Alt Text';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  onChange(value: any, fieldName: keyof MomentsVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof MomentsVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
